import {getCookie, setCookie} from 'tiny-cookie';
const getJSON = (key) => {
  try {
    return JSON.parse(decodeURIComponent(getCookie(key)));
  } catch (e) {
    return null;
  }
};
const setJSON = (key, value, options) => {
  //注意中文存放在Cookie会出错
  setCookie(key, encodeURIComponent(JSON.stringify(value)), options);
}

export default {getJSON, setJSON, setCookie, getCookie};
